/** Common DTOs unique keys */
export enum CommonDtoKeysEnum {
  /** Application short description response body */
  APPLICATION_DESCRIPTION_DTO = 'common/application-description.dto',
  /** API error response body */
  API_ERROR_DTO = 'common/api-error.dto',
  /** Auto-disableable object common request and response body */
  AUTO_DISABLEABLE_DTO = 'common/auto-disableable.dto',
  /** Common parsed URL parameters with `:id` numeric parameter */
  DEFAULT_ID_PARAM_DTO = 'common/default-id-param.dto',
  /** Common parsed URL parameters with `:id` string parameter */
  DEFAULT_ID_STRING_PARAM_DTO = 'common/default-id-string-param.dto',
  /** Common parsed URL parameters with or without `:id` numeric parameter */
  OPTIONAL_ID_PARAM_DTO = 'common/optional-id-param.dto',
  /** Pagination query parameters */
  PAGINATION_QUERY_DTO = 'common/pagination-query.dto',
  /** Standard items list with pagionation API response body */
  PAGINATION_FIND_DTO = 'common/pagination-find.dto',
  /** Standard items list with pagionation API response body (required) */
  PAGINATION_REQUIRED_FIND_DTO = 'common/pagination-required-find.dto',
  /** Common change history log entry base data */
  HISTORY_BASE_DTO = 'common/history-base.dto',
  /** Common change history log entry response body */
  HISTORY_FIND_DTO = 'common/history-find.dto',
  /** Common change history log entries page response body */
  HISTORY_PAGE_DTO = 'common/history-page.dto',
  /** Common change history log target response body */
  HISTORY_TARGET_FIND_DTO = 'common/history-target-find.dto',
  /** Common dates range query */
  DATE_RANGE_QUERY_DTO = 'common/date-range-query.dto',
  /** Common dates range query (required) */
  DATE_RANGE_REQUIRED_QUERY_DTO = 'common/date-range-required-query.dto',
  /** Data range with pagination params */
  DATE_RANGE_WITH_PAGINATION_QUERY_DTO = 'common/date-range-with-pagination-query.dto',
  /** Serialized 1C ERP error. Using by some APIs working with 1C ERP. */
  CONNECTION_1C_ERROR_DTO = 'common/connection-1c-error.dto',
  /** Container object for standard `withDeleted` query parameter */
  WITH_DELETED_QUERY_DTO = 'common/with-deleted-query.dto',
  /** Container object for standard `listStyle` query parameter */
  LIST_STYLE_QUERY_DTO = 'common/list-style-query.dto',
  /** Common search query parameters */
  SEARCH_QUERY_DTO = 'common/search-query.dto',
  /** Common find query parameters */
  FIND_QUERY_DTO = 'common/find-query.dto',
  /** Same as `FindQueryDto` but without required pagination parameters */
  FIND_QUERY_WITHOUT_PAGINATION_DTO = 'common/find-query-without-pagination.dto',
  /** Common form with email to validate */
  EMAIL_QUERY_DTO = 'common/email-query.dto',
  /** Common response body for some APIs and events which return new fact spent time in minutes */
  FACT_MIN_DTO = 'common/fact-min.dto',
  /** Common IDs' filters query parameters */
  IDS_QUERY_DTO = 'common/ids-query.dto',
  /** Common dropdown APIs filters query parameters */
  DROPDOWN_BASE_QUERY_DTO = 'common/dropdown-base-query.dto',
  /** Planning unit settings response body */
  PLANNING_UNIT_FIND_DTO = 'common/planning-unit-find.dto',
  /** Planning unit settings create/update request body */
  PLANNING_UNIT_FORM_DTO = 'common/planning-unit-form.dto',
  /** Deadline settings response body */
  DEADLINE_FIND_DTO = 'common/deadline-find.dto',
  /** Deadline settings create/update request */
  DEADLINE_FORM_DTO = 'common/deadline-form.dto',
  /** Common JSON "page" structure */
  PAGE_FIND_DTO = 'common/page-find.dto',
  /** Common signature for "status" objects (project status, HD task status etc.) */
  STATUS_LIKE_FIND_DTO = 'common/status-like-find.dto',
  /** Pagination query params */
  PAGINATION_WITHOUT_ITEMS_QUERY_DTO = 'common/pagination-without-items-query.dto',
  /** Global basic search item body */
  GLOBAL_BASIC_SEARCH_ITEM_DTO = 'common/global-basic-search-item.dto',
  /** Global basic search result body */
  GLOBAL_BASIC_SEARCH_RESULT_DTO = 'common/global-basic-search-result.dto',
  /** Global basic search query body */
  GLOBAL_BASIC_SEARCH_QUERY_DTO = 'common/global-basic-search-query.dto',
}
